import Checklist from '../../services/checklist'
import * as types from '../mutationTypes'

let state = {
  checklists: null,
  addedChecklist: null,
  deletedChecklist: null,
  updatedChecklist: null,
  selectedChecklist: null,
  checklistId: null,
  checklistLabels: null,
  checklistTaskId: null,
  checklistObjects: {},
  error: null

}
const getters = {
  checklists (state) {
    return state.checklists.map(cl => {
      return { text: cl, value: cl.id }
    })
  },
  checklistLabels (state) {
    return state.checklistLabels
  },
  selectedChecklist (state) {
    return state.selectedChecklist
  },
  checklistId (state) {
    return state.checklistId
  },
  checklistTaskId (state) {
    return state.checklistTaskId
  },
  checklistObjects (state) {
    return state.checklistObjects
  },
  error (state) {
    return state.error
  }
}
const actions = {
  async loadChecklistLabels ({ commit, dispatch }) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Checklist.getLabels()
      if (res) {
        commit(types.REQUEST_GET_ALL_CHECKLISTS_LABELS_SUCCESS, res.data)
      }
    } catch (error) {
      commit(types.REQUEST_GET_ALL_CHECKLISTS_LABELS_ERROR, error.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadChecklistByTask ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Checklist.getByTask(id)
      if (res) {
        commit(types.REQUEST_GET_CHECKLIST_BY_TASK_SUCCESS, res.data)
      }
    } catch (error) {
      commit(types.REQUEST_GET_CHECKLIST_BY_TASK_ERROR, error.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadChecklistById ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    let res = await Checklist.get(id)
    try {
      if (res) {
        commit(types.REQUEST_GET_CHECKLIST_BY_ID_SUCCESS, res.data)
      }
    } catch (error) {
      commit(types.REQUEST_GET_CHECKLIST_BY_ID_ERROR, error.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async addChecklist ({ commit, dispatch }, checklist) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      checklist.name = ''
      let res = await Checklist.add(checklist)
      if (res) {
        commit(types.REQUEST_ADD_CHECKLST_SUCCESS, res.data)
        return res.data
      }
    } catch (error) {
      commit(types.REQUEST_ADD_CHECKLST_ERROR, error.message)
      return null
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateChecklist ({ commit, dispatch }, checklist) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let id = checklist.id
      let res = await Checklist.update(id, checklist)
      if (res) {
        commit(types.REQUEST_UPDATE_CHECKLIST_SUCCESS, res.data)
        dispatch('loadChecklistById', res.data.id)
        dispatch('loadChecklistLabels')
      }
    } catch (error) {
      commit(types.REQUEST_UPDATE_CHECKLIST_ERROR, error.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async deleteChecklist ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Checklist.delete(id)
      if (res) {
        commit(types.REQUEST_DELETE_CHECKLIST_SUCCESS, res.data)
        dispatch('loadChecklistLabels')
      }
    } catch (error) {
      commit(types.REQUEST_DELETE_CHECKLIST_ERROR, error.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clearingChecklist ({ state }) {
    state.selectedChecklist = null
  }
}
const mutations = {
  [types.REQUEST_GET_ALL_CHECKLISTS_LABELS_SUCCESS] (state, data) {
    state.checklistLabels = data
    state.error = null
  },
  [types.REQUEST_GET_ALL_CHECKLISTS_LABELS_ERROR] (state, message) {
    state.checklistLabels = null
    state.error = message
  },
  [types.REQUEST_GET_CHECKLIST_BY_TASK_SUCCESS] (state, data) {
    state.selectedChecklist = data
    state.error = null
  },
  [types.REQUEST_GET_CHECKLIST_BY_TASK_ERROR] (state, message) {
    state.selectedChecklist = null
    state.error = message
  },
  [types.REQUEST_GET_CHECKLIST_BY_ID_SUCCESS] (state, data) {
    state.selectedChecklist = data
    state.error = null
  },
  [types.REQUEST_GET_CHECKLIST_BY_ID_ERROR] (state, message) {
    state.selectedChecklist = null
    state.error = message
  },
  [types.REQUEST_ADD_CHECKLST_SUCCESS] (state, data) {
    state.addedChecklist = data
    state.error = null
  },
  [types.REQUEST_ADD_CHECKLST_ERROR] (state, message) {
    state.addedChecklist = null
    state.error = message
  },
  [types.REQUEST_UPDATE_CHECKLIST_SUCCESS] (state, data) {
    state.updatedChecklist = data
    state.error = null
  },
  [types.REQUEST_UPDATE_CHECKLIST_ERROR] (state, message) {
    state.updatedChecklist = null
    state.error = message
  },
  [types.REQUEST_DELETE_CHECKLIST_SUCCESS] (state, data) {
    state.deletedChecklist = data
    state.error = null
  },
  [types.REQUEST_DELETE_CHECKLIST_ERROR] (state, message) {
    state.deletedChecklist = null
    state.error = message
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
